import { css } from "emotion";
import {
  Dialog,
  DialogType,
  PrimaryButton,
  ScrollablePane,
  Stack
} from "office-ui-fabric-react";
import React from "react";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { DialogProps } from "../../../types/types";
import { renderTextField } from "../../FormFields";

export const loginFormId = "LoginForm";

export interface LoginDialogProps {
  dialogProps: DialogProps;
  submit: (values: any) => void;
}

export const LoginDialog = (props: LoginDialogProps) => {
  const { dialogProps, submit } = props;

  const Form = (formProps: InjectedFormProps) => {
    const { error, handleSubmit, submitting } = formProps;

    const tokens = {
      fiveGapStack: {
        childrenGap: 10,
        padding: 20
      }
    };

    return (
      <Dialog
        hidden={!dialogProps.isOpen}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: dialogProps.title,
          styles: { header: { textAlign: "center" } }
        }}
        modalProps={{
          isBlocking: dialogProps.isModal,
          containerClassName: css`
            height: 300px;
            max-height: 300px;
            width: 400px;
            max-width: 400px;
          `
        }}
      >
        <form id={loginFormId} onSubmit={handleSubmit} noValidate={true}>
          <div
            className={css`
              height: 200px;
            `}
          >
            <ScrollablePane>
              <Stack tokens={tokens.fiveGapStack}>
                {error && (
                  <Stack.Item
                    align="stretch"
                    className={css`
                      text-align: center;
                      color: red;
                      font-size: large;
                    `}
                  >
                    <strong>{error}</strong>
                  </Stack.Item>
                )}
                <Stack.Item align="auto">
                  <Field
                    name="username"
                    placeholder="Username"
                    type="text"
                    iconProps={{ iconName: "Contact" }}
                    component={renderTextField}
                  />
                </Stack.Item>
                <Stack.Item align="auto">
                  <Field
                    name="password"
                    placeholder="Password"
                    type="password"
                    iconProps={{ iconName: "PermissionsSolid" }}
                    component={renderTextField}
                  />
                </Stack.Item>
                <Stack.Item align="auto">
                  <PrimaryButton
                    text="LOGIN"
                    type="submit"
                    className={css`
                      width: 100%;
                    `}
                    form={loginFormId}
                    disabled={submitting}
                  />
                </Stack.Item>
              </Stack>
            </ScrollablePane>
          </div>
        </form>
      </Dialog>
    );
  };

  const ConnectedForm = reduxForm({
    form: loginFormId,
    validate: validator,
    touchOnBlur: false
  })(Form);
  return <ConnectedForm onSubmit={submit} />;
};

const validator = (values: any) => {
  const errors: any = {};

  if (!values.username) {
    errors.username = "ユーザー名は必須です";
  }
  if (!values.password) {
    errors.password = "パスワードは必須です";
  }

  return errors;
};
